{
  "actions": "الإجراءات",
  "activeStakes": "عمليات التكديس النشطة",
  "apy": "العائد السنوي",
  "claimNow": "طالب الآن",
  "claimRewards": "استلام المكافآت",
  "claimRewardsFailed": "فشل استلام المكافآت.",
  "days": "أيام",
  "duration": "المدة",
  "enterExaltAmount": "أدخل كمية EXALT",
  "enterStakeAmount": "أدخل المبلغ المراد رهنه",
  "enterValidExaltAmount": "يرجى إدخال كمية EXALT صحيحة.",
  "enterValidStakeAmount": "الرجاء إدخال مبلغ رهان صحيح.",
  "estimatedApr": "معدل العائد المتوقع",
  "estimatedRewards": "المكافآت المقدرة",
  "exaltStaking": "تكديس EXALT",
  "insufficientBalance": "رصيد EXALT غير كافٍ.",
  "loading": "جاري التحميل...",
  "lockPeriod": "فترة القفل",
  "minimumStake": "الحد الأدنى للرهان",
  "nextReward": "المكافأة التالية",
  "noActiveStakesYet": "لا توجد عمليات تكديس نشطة",
  "noRewardHistory": "لا يوجد سجل مكافآت.",
  "pendingReward": "المكافأة المعلقة",
  "processing": "جاري المعالجة...",
  "rewardHistory": "سجل المكافآت",
  "rewardRate": "معدل المكافأة",
  "rewardsClaimedSuccessfully": "تم استلام المكافآت بنجاح.",
  "rewardsEarned": "المكافآت المكتسبة",
  "securityNotice": "إشعار أمني",
  "serverError": "خطأ في الخادم.",
  "sessionExpired": "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
  "stake": "تكديس",
  "stakeCompleted": "مكتمل",
  "stakeExalt": "تكديس EXALT",
  "stakeHistory": "سجل الرهان",
  "stakeNow": "راهن الآن",
  "stakingFailed": "فشل التكديس.",
  "stakingSecurity1": "يتم إضافة المكافآت بعد التحقق من الخادم.",
  "stakingSecurity2": "قد يتم تطبيق قواعد إلغاء الرهان المبكر.",
  "stakingSecurity3": "قد تكون موافقة المالك/المسؤول مطلوبة في حالات استثنائية.",
  "stakingSecurity4": "يتم التحقق من تأكيدات البلوكتشين قبل المعالجة.",
  "stakingStartedSuccessfully": "تم بدء التكديس بنجاح.",
  "stakingSubtitle": "قم بتكديس EXALT واحصل على مكافآت مستمرة",
  "stakingTitle": "رهان EXALT",
  "totalRewards": "إجمالي المكافآت",
  "totalStaked": "إجمالي المرهون",
  "unavailable": "غير متاح",
  "unstake": "إلغاء التكديس",
  "unstakeFailed": "فشل إلغاء التكديس.",
  "unstakeNow": "إلغاء الرهان الآن",
  "unstakedSuccessfully": "تم إلغاء التكديس بنجاح."
}